var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toSnake } from '~/utils/toSnakeCase';
export default class BaseEngineApi {
    constructor(route) {
        const apiUrl = window.RG_CONFIG.ENGINE_API_URL;
        this.route = route;
        this.url = `${apiUrl}${route}`;
        this.useMock = window.location.search.includes('MOCK_E2E');
    }
    newRoute(route) {
        return new BaseEngineApi(route);
    }
    get(searchParams, asText) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = this.url;
            if (searchParams) {
                const urlParams = new URLSearchParams();
                for (const key of Object.keys(searchParams)) {
                    const value = searchParams[key];
                    if (value !== undefined)
                        urlParams.append(toSnake(key), value);
                }
                url += '?' + urlParams.toString();
            }
            const response = yield fetch(url, {
                method: 'GET',
                mode: 'cors',
                headers: { Accept: 'application/json' },
                credentials: 'include',
            });
            if (response && response.status === 200) {
                if (asText) {
                    return yield response.text();
                }
                return yield response.json();
            }
            throw Error(`Received status code of ${response.status} calling ${this.url}: ${yield response.text()}`);
        });
    }
    post(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(payload),
            });
            if (response && response.status === 200) {
                return yield response.json();
            }
            throw Error(`Received status code of ${response.status} calling ${this.url}: ${yield response.text()}`);
        });
    }
    put(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(this.url, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(payload),
            });
            if (response && response.status === 200) {
                return yield response.json();
            }
            throw Error(`Received status code of ${response.status} calling ${this.url}: ${yield response.text()}`);
        });
    }
    patch(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(this.url, {
                method: 'PATCH',
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(payload),
            });
            if (response && response.status === 200) {
                return yield response.json();
            }
            throw Error(`Received status code of ${response.status} calling ${this.url}: ${yield response.text()}`);
        });
    }
}
